"use client";

import { postApi } from "@src/config/apiWithAxios"
import { URL_POST_JOIN } from "@src/constant/api-url"

export const postJoin = async (payload, slug) => {
  const URL = !!slug ? `${URL_POST_JOIN}?company_slug=${slug}` : URL_POST_JOIN
  const res = await postApi(URL_POST_JOIN, payload);

  return res?.data?.data
}
